import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      
      <div className="privacy-content">
        <div className="privacy-hero">
          <h1 className="privacy-title">TW Rental Privacy Policy</h1>
          <p className="privacy-subtitle">Effective Date: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </div>
        
        <div className="privacy-sections">
          <div className="privacy-section">
            <p>TW Rental ("we," "our," "us") values your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and protect your information when you interact with us, including through SMS or other messaging services.</p>
          </div>
          
          <div className="privacy-section">
            <h2>1. Information We Collect</h2>
            <p>We may collect the following information to provide you with automated customer support and transactional messages:</p>
            <ul>
              <li>Your name</li>
              <li>Phone number</li>
              <li>Booking and rental information</li>
              <li>Communication preferences and related details</li>
            </ul>
            <p>We collect this information directly from you or from the platform you used to make your rental reservation (such as Turo).</p>
          </div>
          
          <div className="privacy-section">
            <h2>2. How We Use Your Information</h2>
            <p>We use your information solely for purposes directly related to your rental and support experience, including:</p>
            <ul>
              <li>Sending booking confirmations and reminders</li>
              <li>Providing pickup and return instructions</li>
              <li>Sharing important support and safety information</li>
              <li>Responding to your inquiries and support requests</li>
            </ul>
            <p>We do not use your phone number for marketing or unrelated promotional purposes.</p>
          </div>
          
          <div className="privacy-section">
            <h2>3. How We Share Your Information</h2>
            <p>We do not sell or rent your personal information.</p>
            <p>We may share limited data with trusted service providers (such as Twilio) to send messages or support customer communication. These providers are required to handle your information securely and in compliance with applicable privacy laws.</p>
          </div>
          
          <div className="privacy-section">
            <h2>4. Consent and Opt-Out</h2>
            <p>By providing your phone number, you consent to receive automated transactional messages from TW Rental regarding your active rental.</p>
            <p>You can opt out of receiving further messages at any time by replying STOP to any message. After opting out, you will no longer receive messages unless you initiate a new rental or support request.</p>
          </div>
          
          <div className="privacy-section">
            <h2>5. Data Retention</h2>
            <p>We retain your personal information only as long as necessary to fulfill the purposes described above, or as required by law. When your data is no longer needed, we securely delete or anonymize it.</p>
          </div>
          
          <div className="privacy-section">
            <h2>6. Data Security</h2>
            <p>We implement reasonable technical and organizational measures to protect your data against unauthorized access, loss, or misuse.</p>
          </div>
          
          <div className="privacy-section">
            <h2>7. Contact Us</h2>
            <p>If you have any questions about this Privacy Policy or our data practices, please contact us at:</p>
            <p>📧 support@twrental.com</p>
            <p>📍 TW Rental</p>
          </div>
          
          <div className="privacy-section">
            <h2>8. Updates to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. The latest version will always be available at this URL.</p>
          </div>
        </div>
      </div>
      
      {/* Footer Section */}
      <div className="privacy-footer">
        <div className="copyright">© 2024 TW Rental. All Rights Reserved.</div>
        <div className="footer-links">
          <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          <span className="footer-separator">|</span>
          <Link to="/contact" className="footer-link">Contact Us</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
